import { AssetKey } from '../model/asset.js';
import { CompanyKey } from '../model/company.js';

export enum SortType {
	Ranking = 'Relevancy',
	Date = 'Newest',
	Alpha = 'Alphabetic',
}

/** Provides the sorting information for a sort.
 *  Note that default values will not be sent to the API
 */
export class SortDetails {
	/** Alphabetic Sort only - the field to sort on. If none is providied, it will use the 'name' field. */
	public field?: AssetKey | CompanyKey = null;
	/**  Whether to use an ascending or descending sort. Default is descending (to align with default for SortType). */
	public direction: 'asc' | 'desc' = 'desc';
	/**Which type of support search will be performed. Default is Ranked. */
	public type: SortType = SortType.Ranking;

	public static get RankedSort(): SortDetails {
		return {
			type: SortType.Ranking,
			direction: 'desc',
		};
	}

	public static get AlphaSort(): SortDetails {
		return {
			type: SortType.Alpha,
			direction: 'asc',
		};
	}

	public static get DateSort(): SortDetails {
		return {
			type: SortType.Date,
			direction: 'desc',
		};
	}
}
